export class validateError extends Error {
    constructor(message = '', code = 0, validate = null) {
        super(message);
        this.errorCode = code;
        this.validate = validate || {};
    }

    getError(key = null) {
        const allError = Object.entries(this.validate)
            .reduce((last, row) => {
                const [key, value] = row;
                if (value && value[0]) {
                    return Object.assign({}, {
                        ...last,
                        [key]: value[0]
                    })
                }
                return last;
            }, {})
        if (key) {
            return allError[key];
        }

        return allError;
    }
}


export class APIError extends Error {
    constructor(message, code = 0) {
        super(message);
        this.errorCode = code;
    }

    getCode() {
        return this.errorCode;
    }
}
